
import { defineComponent, toRaw } from "vue"

export default defineComponent({
  data: () => ({
    cards: toRaw([
      "через региональные организации ВОИР, <br> по&nbsp;электронным адресам, указанным <br> в&nbsp;«<a href='/doc/clause.pdf' target='_blank'>Положении о&nbsp;Конкурсе</a>».",
      "заполнить заявку в&nbsp;личном <br> кабинете сайта <a href='/user/contest'>voirfest.ru.</a>",
      "отправить заполненную заявку <br> на&nbsp;электронную почту: <a href='mailto:info@voirfest.ru'>info@voirfest.ru</a>",
    ] as const),
    docs: toRaw([
      {
        text: "Положение о&nbsp;II&nbsp;Всеросиийском конкурсе «Изобретатель года»",
        link: "/doc/clause.pdf",
      },
      {
        text: "Форма заявки на&nbsp;участие во&nbsp;II&nbsp;Всеросиийском конкурсе «Изобретатель года»",
        link: "/doc/form.docx",
      },
    ] as const),
  }),
})
